export const addLiveLaunchAliasesToCategory = games => categories => categories.map(category => {
    const liveLaunchAliases = category.gameCodes
        .map((gameCode) => games[gameCode]?.liveLaunchAlias)
        .filter(Boolean);

    return {
        ...category,
        liveLaunchAliases
    };
});
